var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsArray, IsDateString, IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import { PatientDocumentationItemType } from '../enums/patient-documentation-item-type.enum.js';
export class PatientDocumentationItemResponseDto {
    id;
    createdAt;
    patientId;
    appointmentId;
    treatmentPlanId;
    type;
    text;
    /** The `FileUpload` ids of this version's files, in attach order. */
    attachmentFileIds;
    authorId;
    replacesItemId;
    struckOutAt;
    struckOutById;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PatientDocumentationItemResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], PatientDocumentationItemResponseDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], PatientDocumentationItemResponseDto.prototype, "patientId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsUUID(),
    __metadata("design:type", Object)
], PatientDocumentationItemResponseDto.prototype, "appointmentId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsUUID(),
    __metadata("design:type", Object)
], PatientDocumentationItemResponseDto.prototype, "treatmentPlanId", void 0);
__decorate([
    Expose(),
    IsEnum(PatientDocumentationItemType),
    __metadata("design:type", String)
], PatientDocumentationItemResponseDto.prototype, "type", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PatientDocumentationItemResponseDto.prototype, "text", void 0);
__decorate([
    Expose(),
    IsArray(),
    IsUUID('all', { each: true }),
    __metadata("design:type", Array)
], PatientDocumentationItemResponseDto.prototype, "attachmentFileIds", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], PatientDocumentationItemResponseDto.prototype, "authorId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDocumentationItemResponseDto.prototype, "replacesItemId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsDateString(),
    __metadata("design:type", Object)
], PatientDocumentationItemResponseDto.prototype, "struckOutAt", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsUUID(),
    __metadata("design:type", Object)
], PatientDocumentationItemResponseDto.prototype, "struckOutById", void 0);
//# sourceMappingURL=patient-documentation-item-response.dto.js.map